












import { Vue, Component, Prop } from 'vue-property-decorator';

import CPBtn from '@/components/buttons/CPBtn/CPBtn.vue';

type ButtonVariant = 'primary' | 'secondary';

@Component({
    components: {
        CPBtn,
    }
})
export default class BaseButton extends Vue {
    @Prop({ default: 'button' }) type!: string
    @Prop({ default: false }) disabled!: boolean
    @Prop({ default: 'primary' }) variant!: ButtonVariant

    get classname() {
        return `cd-btn-${this.variant} cd-btn-radius-50`
    }

    click() {
        this.$emit('click')
    }
}
